"use client";

import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import FormCard from "../../components/FormCard";
import {
  formFieldDate,
  formFieldsSign,
} from "../../components/FormCard/formFields";
import { mapGender } from "../../constants";
import { AstroUserData } from "../../Enum";
import styles from "./Partner.module.scss";

const Partner = () => {
  const router = useRouter();
  const [submit, setSubmit] = useState(false);
  const [maleData, setMaleData] = useState<AstroUserData>();
  const [femaleData, setFemaleData] = useState<AstroUserData>();

  const getFormData = (formName: string, data: AstroUserData | null) => {
    if (!data) {
      setSubmit(false);
      return;
    }

    const newData = {
      ...data,
      gender: mapGender?.[data?.gender]?.toLowerCase(),
    };

    if (formName === "maleData") {
      setMaleData(newData);
    }
    if (formName === "femaleData") {
      setFemaleData(newData);
    }
  };

  const handleSubmit = () => {
    setSubmit(true);
    setTimeout(() => setSubmit(false), 500);
  };

  useEffect(() => {
    if (maleData?.dob && femaleData?.dob) {
      router.push(
        `/free-reports/partner/report?maleData=${JSON.stringify(
          maleData
        )}&femaleData=${JSON.stringify(femaleData)}`
      );
    }
  }, [maleData, femaleData]);

  return (
    <div>
      <div className={styles.zodiacWrapper}>
        <form className={styles.formWrapper}>
          <FormCard
            initialData={{}}
            submit={submit}
            formFields={formFieldDate}
            gender="Male"
            onSubmit={getFormData}
            title="Your Data"
          />
        </form>
        <form className={styles.formWrapper}>
          <FormCard
            initialData={{}}
            submit={submit}
            formFields={formFieldDate}
            gender="Female"
            onSubmit={getFormData}
            title="Partner Data"
          />
        </form>
      </div>
      <div className={styles.buttonWrapper}>
        <button onClick={handleSubmit}>Submit</button>
      </div>
    </div>
  );
};

export default Partner;
